export enum ButtonVariant {
  DEFAULT = "DEFAULT",
  WHITE = "WHITE",
  LINK = "LINK",
  TRANSPARENT = "TRANSPARENT",
}
